import React, { useState, useEffect } from "react";
import axios from "axios";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const cardTextStyle = "!text-[14px]";
  const titleTextStyle = "font-bold !text-[18px]";
  const sessionId = localStorage.getItem("currentSessionId");
useEffect(() => {
  if (!sessionId) {
    console.warn("Session ID missing, skipping notification fetch");
    setLoading(false);
    return;
  }

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/notifications/getNotification`,
        { params: { sessionId } }
      );

      const allNotifications = response.data;

      const filteredNotifications = allNotifications
        .filter(
          (notification) =>
            notification.sendTo === "teachers" ||
            notification.sendTo === "both"
        )
        .map((notification) => ({
          ...notification,
          deleteDate: new Date(notification.deleteDate)
            .toISOString()
            .split("T")[0],
        }));

      const sortedNotifications = filteredNotifications.sort(
        (a, b) => new Date(b.deleteDate) - new Date(a.deleteDate)
      );

      setNotifications(sortedNotifications);
    } catch (error) {
      console.error("Error fetching notifications:", error.response?.data || error);
    } finally {
      setLoading(false);
    }
  };

  fetchNotifications();
}, [sessionId]); // ✅ IMPORTANT


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const isExpired = (dateStr) => new Date(dateStr) < new Date();

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <i className="fas fa-bell text-blue-600 !text-[20px]" />
          <h1 className={titleTextStyle}>Teacher Notifications</h1>
        </div>
      </div>
      <p className={`text-gray-600 mb-4 ${cardTextStyle}`}>
        View all notifications sent to teachers.
      </p>

      {/* Loader */}
      {loading ? (
        <div className="flex justify-center py-8">
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-10 w-10" />
        </div>
      ) : (
        <>
          {notifications.length === 0 ? (
            <p className={`text-center text-gray-500 ${cardTextStyle}`}>
              No notifications available at the moment.
            </p>
          ) : (
            <div className="space-y-4">
              {notifications.map((notification, index) => {
                const expired = isExpired(notification.deleteDate);
                return (
                  <div
                    key={index}
                    className={`border rounded-lg p-4 shadow-sm hover:shadow-md transition bg-white ${
                      expired ? "border-red-300" : "border-gray-200"
                    }`}
                  >
                    {/* Title + Date */}
                    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
                      <h3 className="font-semibold text-gray-900 !text-[16px]">
                        {notification.title}
                      </h3>
                      <p
                        className={`!text-[13px] ${
                          expired ? "text-red-500" : "text-gray-500"
                        } flex items-center gap-1`}
                      >
                        <i className="fas fa-calendar-alt text-yellow-700" />
                        {formatDate(notification.deleteDate)}
                      </p>
                    </div>

                    {/* Content */}
                    <p
                      className={`text-gray-700 mt-2 leading-relaxed ${cardTextStyle}`}
                    >
                      {notification.content}
                    </p>

                    {/* Attachment */}
                    {notification.attachFile && (
                      <a
                        href={notification.attachFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-2 inline-flex items-center gap-2 text-blue-600 !text-[13px] hover:underline"
                      >
                        <i className="fas fa-paperclip" />
                        View Attachment
                      </a>
                    )}

                    {/* Expired Flag */}
                    {expired && (
                      <div className="mt-2 flex items-center gap-2 text-red-500 !text-[13px]">
                        <i className="fas fa-exclamation-circle" />
                        This notification has expired.
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Notification;
